import { Outlet } from 'react-router-dom';

function App() {
  return (
    <div className='bg-white text-neutral-900 min-h-screen'>
      <Outlet />
    </div>
  );
}

export default App;
